import * as Actions from "../constant/ActionTypes";
import * as api from '../../api';

// Add a user entry
export const listPlacedCamPositions = (hwid) => async (dispatch) => {
    try {
        const { data } = await api.listPlacedCamPositions(hwid);

        dispatch({
            type: Actions.LIST_PLACED_CAM_POSITIONS,
            payload: data
        })
    } catch (error) {
        console.log(error);
    }
}